export const PASSWORD_REGEX = /^(?=\D*\d)(?=[^A-Z]*[A-Z])(?=.*[!@#$%^&*]).{8,}$/;
